import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PageLoadService {
    _load = new BehaviorSubject(true);
  constructor() { }
}
